import { LegalPageRenderer } from "../components/legal/LegalPageRenderer";
import { SOCIAL_DISCLAIMER } from "../data/legal";

export function SocialMediaDisclaimerPage() {
  return <LegalPageRenderer content={SOCIAL_DISCLAIMER} />;
}
